import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { FilterFieldsCollector } from "./helpers/FilterFieldsCollector.js";
import { FilterEvaluator } from "./helpers/FilterEvaluator.js";
import { Field } from "../coreComponents/Field.js";
import { Component } from "../coreComponents/Component.js";
import { useEntity } from "../accessorPropagation/useEntity.js";
import { QueryLanguage } from "../queryLanguage/QueryLanguage.js";
import { useEnvironment } from "../accessorPropagation/useEnvironment.js";
const If = Component(
  (props) => {
    return typeof props.condition !== "function" ? /* @__PURE__ */ jsx(IfFilter, { condition: props.condition, children: props.children }) : /* @__PURE__ */ jsx(IfCallback, { condition: props.condition, children: props.children });
  },
  "If"
);
const IfCallback = Component(
  ({ children, condition }) => {
    const entity = useEntity();
    const evaluated = useMemo(() => condition(entity), [condition, entity]);
    return evaluated ? /* @__PURE__ */ jsx(Fragment, { children }) : null;
  },
  ({ children }) => {
    return /* @__PURE__ */ jsx(Fragment, { children });
  },
  "IfCallback"
);
const IfFilter = Component(
  ({ children, condition }) => {
    const env = useEnvironment();
    const entity = useEntity();
    const schema = env.getSchema();
    const evaluated = useMemo(
      () => new FilterEvaluator(schema).evaluateFilter(entity, QueryLanguage.desugarFilter(condition, env)),
      [condition, entity, env, schema]
    );
    return evaluated ? /* @__PURE__ */ jsx(Fragment, { children }) : null;
  },
  ({ children, condition }, env) => {
    const desugaredFilter = QueryLanguage.desugarFilter(condition, env);
    const collectedFields = new FilterFieldsCollector(env.getSchema(), desugaredFilter).collectFields(env.getSubTreeNode().entity);
    const additionalFields = /* @__PURE__ */ jsx(Fragment, { children: Array.from(collectedFields).map((it) => /* @__PURE__ */ jsx(Field, { field: it }, it)) });
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      additionalFields,
      children
    ] });
  },
  "IfFilter"
);
export {
  If
};
//# sourceMappingURL=If.js.map
